import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent } from '@mui/material/Select';

/** A mortality reason or a disease; both lists feed this select. A missing name renders as '-'. */
export interface AnimalDieReasonSelectOption {
  id: string;
  name: string | null;
}

interface AnimalDieReasonSelectProps {
  options: AnimalDieReasonSelectOption[];
  value: string;
  onChange: (value: string) => void;
  labelKey: string;
  cssClass?: string;
  fullWidth?: boolean;
  allowAny?: boolean;
  disabled?: boolean;
  selectId?: string;
  labelText?: string;
}

const AnimalDieReasonSelect = ({
  options,
  value,
  onChange,
  labelKey,
  cssClass,
  fullWidth,
  allowAny,
  disabled,
  selectId,
  labelText
}: AnimalDieReasonSelectProps) => {
  const { t } = useTranslation();

  const handleChange = (e: SelectChangeEvent<string>) => {
    onChange(e.target.value);
  };

  const label = labelText || t(labelKey);

  return (
    <FormControl className={cssClass} disabled={disabled} fullWidth={fullWidth} variant="outlined" size="small">
      <InputLabel id={`${selectId || 'SimpleSelect'}-label`}>{label}</InputLabel>
      <Select
        label={label}
        labelId={`${selectId || 'SimpleSelect'}-label`}
        id={selectId || 'SimpleSelect'}
        value={value}
        onChange={handleChange}
      >
        <MenuItem value="">—</MenuItem>

        {allowAny && (
          <MenuItem key="any" value="any">
            {t('f-any')}
          </MenuItem>
        )}

        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            {opt.name ?? '-'}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AnimalDieReasonSelect;
